import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "reactstrap";
import { API_URL } from "../../config";
import { CustomButton } from "../../Common/Components/Button/CustomButton";

export function CustomReimbursementAttachmentView({ dataFile, editMode, onClickDelete, onClickEdit, embedded = false }) {
    const { t } = useTranslation();

    const isReadOnlyProceeding = editMode === undefined && !onClickDelete && !onClickEdit;

    if (isReadOnlyProceeding && embedded) {
        if (!dataFile || dataFile.length === 0) return null;

        return (
            <div style={{ marginTop: 14 }}>
                <div className="reimbursement-section-subtitle">Bilaga</div>

                <div className="reimbursement-file-items">
                    {dataFile.map((item, index) => {
                        if (!item?.fileId) return null;

                        const fileName = item?.fileExtension || "Bilaga";
                        return (
                            <a
                                key={`attachment-embedded-${item?.fileId ?? index}`}
                                href={`${API_URL}/file?id=${item.fileId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none"
                            >
                                <div className="reimbursement-file-item">
                                    <div className="reimbursement-file-left">
                                        <div className="reimbursement-file-icon">
                                            <i className="bx bx-file" />
                                        </div>
                                        <div className="reimbursement-file-name">{fileName}</div>
                                    </div>
                                    <i className="bx bx-chevron-right reimbursement-file-arrow" />
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <>
            {/* ===== FILE LIST ===== */}
            {dataFile && dataFile.length > 0 ? (
                dataFile.map((item, index) => (
                    <Col lg={12} key={`participant${index}`} className="mt-1">
                        <Card className="bg-card-grey p-3">
                            <Row>
                                <Col lg={12}>
                                    <Row className="d-flex align-items-center">
                                        <Col xxl={item.status !== 'Förslag' || editMode ? 12 : 9} className="order-1 order-xxl-0 pe-3">
                                            <Row className="d-flex align-items-center">  
                                                <Col xs={4} md={3}>
                                                        <span className="fw-bold text-black">Övriga underlag:</span>
                                                </Col>                                        
                                                <Col xs={8} md={9} className="text-center">
                                                    {item.fileExtension && item.fileId &&
                                                     dataFile.findIndex(d => d.fileId === item.fileId) === index && (
                                                        <a
                                                            href={`${API_URL}/file?id=${item.fileId}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >                                                            
                                                            <i className="bx bx-file fs-3 text-green" />
                                                        </a>
                                                    )}                                                     
                                                </Col>                                                                                                       
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                ))
            ) : null}         
        </>
    );
}
